import script from './component-lib.esm4.js';
export { InputBtnProps } from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.isInput ? 'div' : 'button', _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-input-btn",
    class: _vm.classes
  }, 'component', Object.assign({}, _vm.$attrs, _vm.rootAttrs), false), _vm.$listeners), [_vm.isInput ? _c('input', _vm._b({
    staticClass: "v-input-btn__radio sr-only",
    attrs: {
      "id": _vm.inputId,
      "type": "radio",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleClick
    }
  }, 'input', _vm.inputAttrs, false)) : _vm._e(), _vm._v(" "), _c(_vm.isInput ? 'label' : 'div', {
    tag: "component",
    staticClass: "v-input-btn__label",
    attrs: {
      "for": _vm.isInput ? _vm.inputId : null
    }
  }, [_c('RatioBox', {
    staticClass: "v-input-btn__content",
    style: "height: " + _vm.contentHeight,
    attrs: {
      "ratio": _vm.ratio
    }
  }, [_c('div', {
    staticClass: "v-input-btn__content__inner"
  }, [_vm._t("content"), _vm._v(" "), _vm.isInput ? _c('span', {
    staticClass: "v-input-btn__content__check"
  }, [_c('CheckIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isChecked,
      expression: "isChecked"
    }],
    attrs: {
      "color": "primary",
      "size": _vm.checkIconSize
    }
  })], 1) : _vm._e()], 2)]), _vm._v(" "), _c('span', {
    staticClass: "v-input-btn__name"
  }, [_vm._t("default")], 2)], 1), _vm._v(" "), _vm._t("after")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-82402d50_0", {
    source: ".v-input-btn[data-v-82402d50]{text-align:center;position:relative}.v-input-btn--button[data-v-82402d50]{background:0 0;border:none;display:block;width:100%;padding:0}.v-input-btn__label:hover .v-input-btn__content[data-v-82402d50]:before,.v-input-btn__radio:focus+.v-input-btn__label .v-input-btn__content[data-v-82402d50]:before{border-color:var(--g-color-primary)}.v-input-btn--checked .v-input-btn__content[data-v-82402d50]:before{border-color:var(--g-color-primary)}.v-input-btn--disabled .v-input-btn__label[data-v-82402d50]{cursor:default;opacity:.7;pointer-events:none}.v-input-btn--centered .v-input-btn__content__inner[data-v-82402d50]{justify-content:center;align-items:center}.v-input-btn__label[data-v-82402d50]{cursor:pointer;display:flex;flex-direction:column}.v-input-btn__content[data-v-82402d50]{background:var(--g-color-gray-100);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min))}.v-input-btn__content[data-v-82402d50]:before{content:\"\";border:.125rem solid transparent;border-radius:inherit;position:absolute;left:-.25rem;top:-.25rem;height:calc(100% + .5rem);width:calc(100% + .5rem);transition:var(--g-transition-speed)}.v-input-btn__content__inner[data-v-82402d50]{border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));display:flex;height:100%;overflow:hidden}.v-input-btn__content__check[data-v-82402d50]{position:absolute;top:.2rem;right:.3rem}.v-input-btn--group-xs .v-input-btn__content__check[data-v-82402d50]{top:.1rem;right:.2rem}.v-input-btn__name[data-v-82402d50]{display:block;font-size:1rem;margin-top:.5rem;word-break:break-all}.v-input-btn--group-xs .v-input-btn__name[data-v-82402d50]{font-size:.875rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-82402d50";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var InputBtn = __vue_component__;
export { InputBtn as default };